import { gql } from "@apollo/client";

export const CHARGER_LOGS = gql`
query charger_status_messages($n: Int, $before: String, $after: String, $where: InputSalesforceChargerOperators) {
  charger_monitors(where: $where) @connection(key: "chargerListErrors") {
    charger_status_messages(n: $n, before: $before, after: $after) {
      edges {
        cursor
        node {
          errorCode
          receiveTimestamp
          serial
          status
          vendorErrorCode
          info
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
}
`;
